module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Readed-mail-d01c07f716298d63e0311b6b8d6d8ba7.svg";